<template dark>
  <div class="renderPage reporte-container animate-fade-in">
    <!-- Main Toolbar -->
    <v-toolbar color="primary" dark flat class="mb-4 rounded-xl" height="64">
      <v-icon class="mr-3" size="28">mdi-account-group-outline</v-icon>
      <v-toolbar-title class="text-subtitle-1 text-sm-h6 font-weight-black px-0 text-uppercase letter-spacing-1">
        Gestión de Usuarios
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon color="white" to="/home" class="glass-btn">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- Tab Navigation -->
    <v-card class="glass-card mb-6 rounded-xl overflow-hidden" elevation="0">
      <v-tabs background-color="transparent" class="custom-tabs" fixed-tabs center-active v-model="tab2">
        <v-tab key="usuarios_registrados" @click="limpiar()" class="font-weight-bold">
          <v-icon left>mdi-account-details</v-icon>
          Usuarios Registrados
        </v-tab>
        <v-tab key="usuarios_nuevos" @click="limpiar()" class="font-weight-bold">
          <v-icon left>mdi-account-edit</v-icon>
          Usuarios
        </v-tab>
      </v-tabs>
    </v-card>

    <v-tabs-items v-model="tab2" class="transparent-tabs-item">
      <!-- TAB: USUARIOS REGISTRADOS -->
      <v-tab-item key="usuarios_registrados">
        <v-card class="glass-card rounded-xl overflow-hidden" elevation="0">
          <div class="px-6 py-4 border-bottom header-glass d-flex align-center justify-space-between flex-wrap">
            <div class="d-flex align-center mb-2 mb-sm-0">
              <v-icon color="primary" class="mr-2">mdi-account-multiple</v-icon>
              <span class="text-subtitle-1 font-weight-bold primary--text">Usuarios Activos</span>
            </div>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Búsqueda rápida" hide-details dense outlined rounded class="modern-input search-input" style="max-width: 300px; width: 100%"></v-text-field>
          </div>
          <v-data-table :headers="headers" :items="items" :search="search" class="premium-table px-2 pb-2">
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn icon color="primary" class="glass-btn" @click="editItem(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <div class="pa-4 text-center">
                <v-btn color="primary" class="rounded-pill" @click="getData()"> Refrescar </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>

      <!-- TAB: USUARIOS (FORM) -->
      <v-tab-item key="usuarios_nuevos">
        <v-form v-model="valid">
          
          <!-- Section 1: General -->
          <v-card class="glass-card mb-6 rounded-xl overflow-hidden" elevation="0">
            <div class="px-6 py-4 border-bottom header-glass">
              <div class="d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-card-account-details-outline</v-icon>
                <span class="text-subtitle-1 font-weight-bold primary--text">Información General</span>
              </div>
            </div>
            <v-card-text class="pa-6">
              <v-row align="center">
                <v-col cols="12" sm="4" md="3">
                  <v-text-field v-model="editedItem.cedula" label="Cedula" class="modern-input" outlined dense rounded :disabled="incluirValid" hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12" sm="8" md="5">
                  <v-text-field v-model="editedItem.nombre" label="Nombre" :rules="nameRules" required class="modern-input" outlined dense rounded :disabled="incluirValid" hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="editedItem.clave" label="Clave" class="modern-input" outlined dense rounded :disabled="incluirValid" hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12" sm="8" md="5">
                  <v-select label="Banca Defecto" item-text="nombre" item-value="companyId" v-model="editedItem.ciaPorDefecto" :items="cias" class="modern-input" outlined dense rounded :disabled="incluirValid" hide-details="auto"></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-text-field v-model="editedItem.porcRegular" label="Porcentaje Comisión" class="modern-input" outlined dense rounded :disabled="incluirValid" hide-details="auto" type="number"></v-text-field>
                </v-col>
                <v-col cols="6" sm="4" md="2" class="d-flex justify-center">
                  <v-checkbox v-model="editedItem.tipo" label="Admin" class="mt-0" color="primary" :disabled="incluirValid" hide-details></v-checkbox>
                </v-col>
                <v-col cols="6" sm="4" md="2" class="d-flex justify-center">
                  <v-checkbox v-model="editedItem.activo" label="Activo" color="success" class="mt-0" :disabled="incluirValid" hide-details></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-row>
            <v-col cols="12" md="6">
              <!-- Section 2: Bancas (Compañías) -->
              <v-card class="glass-card mb-6 rounded-xl overflow-hidden fill-height d-flex flex-column" elevation="0">
                <div class="px-6 py-4 border-bottom header-glass">
                  <div class="d-flex align-center">
                    <v-icon color="primary" class="mr-2">mdi-storefront</v-icon>
                    <span class="text-subtitle-1 font-weight-bold primary--text">Configuración de Compañías</span>
                  </div>
                </div>
                <v-card-text class="pa-6 flex-grow-1">
                  <v-row align="center">
                    <v-col cols="12" sm="8">
                      <v-select label="Asignar Banca" item-text="nombre" item-value="companyId" v-model="ciaDropDown" :items="cias" @change="changeCia" :disabled="incluirValid" class="modern-input" outlined dense rounded hide-details></v-select>
                    </v-col>
                    <v-col cols="12" sm="4" class="text-center text-sm-left">
                      <v-btn color="primary" class="rounded-pill shadow-soft font-weight-bold px-6 w-100" height="40" @click="saveCias" :disabled="incluirValid">
                        <v-icon left>mdi-plus</v-icon>
                        Agregar
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-data-table :headers="headersCias" :items="companies" class="premium-table mt-4" hide-default-footer>
                    <template v-slot:top>
                      <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card class="theme-aware-dialog">
                          <v-card-title class="text-h6 justify-center pt-6">¿Desea descartar la compañia?</v-card-title>
                          <v-card-actions class="pb-6 justify-center">
                            <v-btn color="grey darken-1" text class="rounded-pill px-4" @click="closeDeleteCias">Cancelar</v-btn>
                            <v-btn color="error" class="rounded-pill px-6 shadow-soft" @click="deleteItemConfirmCias">Confirmar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                      <v-btn icon color="error" class="glass-btn-error" @click="deleteItemCias(item)">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <!-- Section 3: Permisos (Seguridad) -->
              <v-card class="glass-card mb-6 rounded-xl overflow-hidden fill-height d-flex flex-column" elevation="0">
                <div class="px-6 py-4 border-bottom header-glass">
                  <div class="d-flex align-center">
                    <v-icon color="primary" class="mr-2">mdi-shield-lock-outline</v-icon>
                    <span class="text-subtitle-1 font-weight-bold primary--text">Permisos de Seguridad</span>
                  </div>
                </div>
                <v-card-text class="pa-6 flex-grow-1">
                  <v-row align="center">
                    <v-col cols="12" sm="5">
                      <v-select label="Categoría de Menú" item-text="titulo" item-value="id" v-model="menuDropDown" :items="menus" @change="getMenuOpciones" :disabled="incluirValid" class="modern-input" outlined dense rounded hide-details></v-select>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-select label="Páginas" item-text="titulo" item-value="id" v-model="menuOpcionesDropDown" :items="menuOpciones" @change="GetMenuOpcion" :disabled="incluirValid" class="modern-input" outlined dense rounded hide-details></v-select>
                    </v-col>
                    <v-col cols="12" sm="3" class="text-center text-sm-left">
                      <v-btn color="primary" class="rounded-pill shadow-soft font-weight-bold px-2 w-100" height="40" @click="savePaginas" :disabled="incluirValid">
                        <v-icon left>mdi-plus</v-icon>
                        Agregar
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-data-table :headers="headersPaginas" :items="paginas" class="premium-table mt-4" :items-per-page="5" :footer-props="{ 'items-per-page-options': [5, 10, 20] }">
                    <template v-slot:top>
                      <v-dialog v-model="dialogDeletePagina" max-width="500px">
                        <v-card class="theme-aware-dialog">
                          <v-card-title class="text-h6 justify-center pt-6">¿Desea descartar la página?</v-card-title>
                          <v-card-actions class="pb-6 justify-center">
                            <v-btn color="grey darken-1" text class="rounded-pill px-4" @click="closeDeletePaginas">Cancelar</v-btn>
                            <v-btn color="error" class="rounded-pill px-6 shadow-soft" @click="deleteItemConfirmPagina">Confirmar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                      <v-btn icon color="error" class="glass-btn-error" @click="deleteItemPagina(item)">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Actions -->
          <v-row justify="center" class="mt-4 mb-8">
            <v-col cols="auto">
              <v-btn color="info" :disabled="!incluirValid" @click="incluir()" class="rounded-pill px-8 font-weight-bold shadow-soft" height="46">
                <v-icon left>mdi-plus-circle-outline</v-icon>
                Nuevo Usuario
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn color="success" :disabled="!guardarValid" @click="save()" class="rounded-pill px-8 font-weight-bold shadow-soft" height="46">
                <v-icon left>mdi-content-save-outline</v-icon>
                Guardar
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn color="error" :disabled="!eliminarValid" @click="deleteItem()" class="rounded-pill px-8 font-weight-bold shadow-soft" height="46">
                <v-icon left>mdi-delete-outline</v-icon>
                Eliminar
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn color="grey darken-1" dark :disabled="!cancelarValid" @click="cerrar()" class="rounded-pill px-8 font-weight-bold shadow-soft" height="46">
                <v-icon left>mdi-cancel</v-icon>
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-tab-item>
      
      <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";
//import Cabys from "./Cabys.vue";

export default {
  components: {
    Snackbar,
    //Cabys,
  },
  dark: true,
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      dialogDeletePagina: false,
      valid: false,
      incluirValid: true,
      cancelarValid: false,
      eliminarValid: false,
      guardarValid: false,
      search: "",
      snackText: "",
      snackValue: false,
      tab2: "",
      esRec: false,
      existeCia: false,
      existePagina: false,
      ciaDropDown: "",
      menuDropDown: "",
      menuOpcionesDropDown: "",
      companies: [],
      menus: [],
      menuOpciones: [],
      paginas: [],
      panel: [],
      modeloPaginaUsuario: {
        usuario: [],
        companies: [],
        paginas: [],
      },
      headers: [
        {
          text: "Cédula",
          align: "start",
          value: "cedula",
        },
        {
          text: "Nombre",
          align: "start",
          value: "nombre",
        },
        { text: "Editar", value: "actions", width: 50, sortable: false },
      ],
      headersCias: [
        {
          text: "Cédula",
          align: "start",
          value: "companyId",
        },
        {
          text: "Nombre",
          align: "start",
          value: "nombre",
        },
        { text: "Eliminar", value: "delete", width: 70, sortable: false },
      ],
      headersPaginas: [
        {
          text: "Menu",
          align: "start",
          value: "menuNombre",
        },
        {
          text: "Página",
          align: "start",
          value: "titulo",
        },
        { text: "Eliminar", value: "delete", width: 70, sortable: false },
      ],
      items: [],
      cias: [],
      tiposIdentificacion: [],
      monedas: [],
      provincias: [],
      cantones: [],
      distritos: [],
      barrios: [],
      codigoArticulo: "",
      editedIndex: -1,
      editedItem: {
        id: 0,
        cedula: "",
        clave: "",
        tipo: 0,
        nombre: "",
        ciaPorDefecto: "",
        porcRegular: 0,
        activo: 0,
      },
      defaultItem: {
        id: 0,
        cedula: "",
        clave: "",
        tipo: 0,
        nombre: "",
        ciaPorDefecto: "",
        porcRegular: 0,
        activo: 0,
      },
      clienteHacienda: {
        nombre: "",
        tipoIdentificacion: "",
        situacion: {
          estado: "",
        },
      },
      ciaeditedIndex: -1,
      ciaeditedItem: {
        nombre: "",
        companyId: "",
      },
      ciadefaultItem: {
        nombre: "",
        companyId: "",
      },
      paginaditedIndex: -1,
      paginaeditedItem: {
        id: 0,
        titulo: "",
        menuId: 0,
        path: "",
        menuNombre: "",
      },
      paginadefaultItem: {
        id: 0,
        titulo: "",
        menuId: 0,
        path: "",
        menuNombre: "",
      },
      showNewData: false,
      nameRules: [(v) => !!v || "Campo requerido"],
    };
  },

  computed: {
    ...mapGetters(["user", "strCia"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    search() {
      this.snackValue = false;
    },
  },

  created() {
    this.getData();
    //this.getTiposIdentificacion();
    //this.getMonedas();
    //this.getProvincias();
  },

  methods: {
    getData() {
      let me = this;
      axios
        .get("api/Usuarios/getUserAll", {
          crossdomain: true,
        })
        //.get("api/Sender/GetTipoDocumento", {crossdomain: true})
        .then(function (response) {
          me.items = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
      //this.snackValue = false
    },

    limpiar() {
      this.snackValue = false;
    },

    deleteItemCias(item) {
      this.ciaeditedIndex = this.companies.indexOf(item);
      this.ciaeditedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemPagina(item) {
      this.paginaditedIndex = this.paginas.indexOf(item);
      this.paginaeditedItem = Object.assign({}, item);
      this.dialogDeletePagina = true;
    },

    deleteItemConfirmCias() {
      this.companies.splice(this.ciaeditedIndex, 1);
      this.closeDeleteCias();
    },

    deleteItemConfirmPagina() {
      this.paginas.splice(this.paginaditedIndex, 1);
      this.closeDeletePaginas();
    },

    closeCias() {
      this.dialog = false;
      this.$nextTick(() => {
        this.ciaeditedItem = Object.assign({}, this.ciadefaultItem);
        this.ciaeditedIndex = -1;
      });
    },

    closePaginas() {
      this.dialog = false;
      this.$nextTick(() => {
        this.paginaeditedItem = Object.assign({}, this.paginadefaultItem);
        this.paginaditedIndex = -1;
      });
    },

    closeDeleteCias() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.ciaeditedItem = Object.assign({}, this.ciadefaultItem);
        this.ciaeditedIndex = -1;
      });
    },

    closeDeletePaginas() {
      this.dialogDeletePagina = false;
      this.$nextTick(() => {
        this.paginaeditedItem = Object.assign({}, this.paginadefaultItem);
        this.paginaditedIndex = -1;
      });
    },

    changeCia() {
      this.getCia();
    },

    saveCias() {
      this.addNewCia();
    },

    savePaginas() {
      this.addNewPagina();
    },

    addNewCia() {
      this.existeCia = false;
      this.companies.find((object) => {
        if (object.companyId === this.ciaDropDown) {
          this.existeCia = true;
        }
      });

      if (this.existeCia === false) {
        if (this.ciaeditedItem.companyId != "") {
          if (this.ciaeditedIndex > -1) {
            // this.snackText = "Existe:" + this.existeCia;
            // this.snackValue = true;
          } else {
            this.companies.push(this.ciaeditedItem);
            this.existeCia = false;
          }
          this.closeCias();
        }
      }
    },

    addNewPagina() {
      this.existePagina = false;
      this.paginas.find((object) => {
        if (object.id === this.menuOpcionesDropDown) {
          this.existePagina = true;
        }
      });

      if (this.existePagina === false) {
        if (this.paginaeditedItem.titulo != "") {
          if (this.paginaditedIndex > -1) {
            // this.snackText = "Existe:" + this.existeCia;
            // this.snackValue = true;
          } else {
            this.paginas.push(this.paginaeditedItem);
            this.existePagina = false;
          }
          this.closePaginas();
        }
      }
    },

    getCia() {
      let me = this;
      axios
        .get("api/Tiempos/GetBancaById?companyId=" + this.ciaDropDown, {
          crossdomain: true,
        })
        .then(function (response) {
          me.ciaeditedItem = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getCias() {
      let me = this;
      axios
        .get("api/Tiempos/getBancas", {
          crossdomain: true,
        })
        .then(function (response) {
          me.cias = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getMenu() {
      let me = this;
      axios
        .get("api/Usuarios/getMenu", {
          crossdomain: true,
        })
        .then(function (response) {
          me.menus = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getMenuOpciones() {
      let me = this;
      axios
        .get("api/Usuarios/getMenuOpciones?menuId=" + this.menuDropDown, {
          crossdomain: true,
        })
        //.get("api/Sender/GetTipoDocumento", {crossdomain: true})
        .then(function (response) {
          me.menuOpciones = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
      //this.snackValue = false
    },

    GetMenuOpcion() {
      let me = this;
      axios
        .get("api/Usuarios/getMenuOpcion?id=" + this.menuOpcionesDropDown, {
          crossdomain: true,
        })
        //.get("api/Sender/GetTipoDocumento", {crossdomain: true})
        .then(function (response) {
          me.paginaeditedItem = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
      //this.snackValue = false
    },

    getPaginas() {
      let me = this;
      axios
        .get("api/Usuarios/getMenuOpciones?menuId=0", {
          crossdomain: true,
        })
        //.get("api/Sender/GetTipoDocumento", {crossdomain: true})
        .then(function (response) {
          me.paginas = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
      //this.snackValue = false
    },

    getCodigoCliente() {
      let me = this;
      axios
        .get("api/Clientes/getCodigoCliente?cia=" + this.strCia)
        .then(function (response) {
          //me.codigoArticulo = response.data;
          me.editedItem.codigo = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTiposIdentificacion() {
      let me = this;
      axios
        .get("api/General/getTiposIdentificacion")
        .then(function (response) {
          me.tiposIdentificacion = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeEsReceptor() {
      // this.snackText = "entra y trae: " + this.editedItem.esReceptor;
      // this.snackValue = true;
      if (this.editedItem.esReceptor === true) {
        this.esRec = true;
      } else {
        this.esRec = false;
      }
    },

    getBarrios() {
      let me = this;
      axios
        .get(
          "api/General/getBarrios?provincia=" +
          this.editedItem.provincia +
          "&canton=" +
          this.editedItem.canton +
          "&distrito=" +
          this.editedItem.distrito
        )
        .then(function (response) {
          me.barrios = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeDistritos() {
      this.getBarrios();
    },

    getDistritos() {
      let me = this;
      axios
        .get(
          "api/General/getDistritos?provincia=" +
          this.editedItem.provincia +
          "&canton=" +
          this.editedItem.canton
        )
        .then(function (response) {
          me.distritos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeCantones() {
      this.getDistritos();
    },

    getCantones() {
      let me = this;
      axios
        .get("api/General/getCantones?provincia=" + this.editedItem.provincia)
        .then(function (response) {
          me.cantones = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeProvincia() {
      this.getCantones();
    },

    getProvincias() {
      let me = this;
      axios
        .get("api/General/getProvincias")
        .then(function (response) {
          me.provincias = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getMonedas() {
      let me = this;
      axios
        .get("api/General/getMonedas")
        .then(function (response) {
          me.monedas = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getClienteHacienda() {
      let me = this;
      axios
        .get(
          "https://api.hacienda.go.cr/fe/ae?identificacion=" +
          me.editedItem.cedula
        )
        .then(function (response) {
          me.clienteHacienda = response.data;
          me.editedItem.nombre = me.clienteHacienda.nombre;
          me.editedItem.nombreComercial = me.clienteHacienda.nombre;
          me.editedItem.tipoId = me.clienteHacienda.tipoIdentificacion;

          if (me.clienteHacienda.situacion.estado === "Inscrito") {
            me.editedItem.esReceptor = true;
            me.esRec = true;
            me.editedItem.areaTel = "506";
          } else {
            me.editedItem.esReceptor = false;
            me.esRec = false;
          }

          //   me.snackText = "estado hacienda"+ me.clienteHacienda.situacion.estado;
          //   me.snackValue = true;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    editItem(item) {
      this.getCias();
      this.getMenu();
      //this.getPaginas();
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.panel = [0, 1];
      this.getModeloPaginaUsuario();

      // this.changeEsReceptor();
      // this.changeProvincia();
      // this.changeCantones();
      // this.changeDistritos();
      //this.changeCantones();
      //this.dialog = true;
      this.tab2 = 1;
      this.cancelarValid = true;
      this.eliminarValid = true;
      this.guardarValid = true;
      this.incluirValid = false;
    },

    // mostrarCabys() {
    //   this.dialog = true;
    //   this.showNewData = true;
    //   this.cancelarValid = true;
    // },

    save() {
      let me = this;

      this.modeloPaginaUsuario.usuario = this.editedItem;
      this.modeloPaginaUsuario.cias = this.companies;
      this.modeloPaginaUsuario.paginas = this.paginas;

      //this.editedItem.cia = this.strCia;
      if (this.editedIndex > -1) {
        axios
          .post("api/Usuarios/UpdateModeloPagina", this.modeloPaginaUsuario)
          .then(function () {
            me.snackText = "Registro modificado satisfactoriamente";
            me.snackValue = true;
            me.getData();
          })
          .catch(function (error) {
            console.log(error);
            // me.saved(false);
          });
      } else {
        axios
          .post("api/Usuarios/insertModeloPagina", this.modeloPaginaUsuario)
          .then(function () {
            me.snackText = "Registro agregado satisfactoriamente";
            me.snackValue = true;
            me.getData();
          })
          .catch(function (error) {
            console.log(error);
            // me.saved(false);
          });
      }
      this.cancelarValid = true;
      this.eliminarValid = true;
      this.guardarValid = true;
      this.incluirValid = false;
      this.snackValue = false;
    },

    getModeloPaginaUsuario() {
      let me = this;
      axios
        .get(
          "api/Usuarios/getModeloPaginaUsuario?usuarioId=" + this.editedItem.id,
          {
            crossdomain: true,
          }
        )
        .then(function (response) {
          me.modeloPaginaUsuario = response.data;
          //this.editedItem = this.editedItem;
          me.companies = me.modeloPaginaUsuario.cias;
          me.paginas = me.modeloPaginaUsuario.paginas;
          me.editedItem.porcRegular = me.modeloPaginaUsuario.usuario.porcRegular;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // validarCampos(){
    //     let me = this;

    //     if(this.editedItem.tipoArt === "") {
    //         return false;
    //     }
    //     else
    //     {
    //         return TRUE;
    //     }

    // },

    deleteItem() {
      let me = this;
      if (confirm("¿Está seguro de que desea eliminar el usuario?")) {
        axios
          .delete("api/Usuarios/deleteUser?usuarioId=" + this.editedItem.id)
          .then(function () {
            me.getData();
          })
          .catch(function (error) {
            console.log(error);
            // me.saved(false);
          });
        this.cerrar();
        this.tab2 = 0;
        this.esRec = false;
      }
    },

    // selected(value) {
    //   this.cabys = Object.assign({}, value);
    //   this.showNewData = false;
    //   this.dialog = false;
    //   //   this.snackText = "codigo: " + this.cabys.codigo + "descripcion: "+ this.cabys.descripcion + "impuesto: " +this.cabys.impuesto ;
    //   //   this.snackValue = true;
    //   this.editedItem.nombre = this.cabys.descripcion;
    //   this.editedItem.cabys = this.cabys.codigo;
    //   this.editedItem.tarifa = this.cabys.impuesto;
    // },

    closed() {
      this.showNewData = false;
      this.dialog = false;
    },

    cerrar() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.valid = false;
        this.cancelarValid = false;
        this.eliminarValid = false;
        this.guardarValid = false;
        this.incluirValid = true;
        this.panel = [];
        this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
        this.menuOpciones = [];
        this.menuOpciones = [];
        this.menus = [];
        this.paginas = [];
        this.companies = [];

        //this.$refs.form.resetValidation();
      });
    },

    incluir() {
      //this.dialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.getCias();
        this.getMenu();
        this.getPaginas();
        this.panel = [0, 1];
        this.getCodigoCliente();
        //this.editedItem.areaTel = "506";
        //this.valid = false;
        this.cancelarValid = true;
        this.eliminarValid = false;
        this.guardarValid = true;
        this.incluirValid = false;
        this.esRec = false;
        //this.$refs.form.resetValidation();
      });
    },
  },
};
</script>

<style scoped>
.reporte-container {
    padding-bottom: 60px;
}

/* Glassmorphism Styles */
.glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.theme--dark .glass-card {
    background: rgba(30, 30, 46, 0.8) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-btn {
    background: rgba(25, 118, 210, 0.1) !important;
}

.glass-btn-error {
    background: rgba(244, 67, 54, 0.1) !important;
}

.header-glass {
    background: rgba(25, 118, 210, 0.03);
}

.theme--dark .header-glass {
    background: rgba(255, 255, 255, 0.02);
}

.border-bottom {
    border-bottom: 1px solid rgba(0,0,0,0.05);
}

.theme--dark .border-bottom {
    border-bottom: 1px solid rgba(255,255,255,0.05);
}

/* Modern Inputs */
.modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(255, 255, 255, 0.5) !important;
    backdrop-filter: blur(4px);
}

.theme--dark .modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(0, 0, 0, 0.2) !important;
}

/* Table Styling */
.premium-table {
    background: transparent !important;
}

.premium-table >>> th {
    background: rgba(0, 0, 0, 0.02) !important;
    font-weight: 800 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 0.75rem !important;
}

.theme--dark .premium-table >>> th {
    background: rgba(255, 255, 255, 0.05) !important;
}

.premium-table >>> tr:hover {
    background: rgba(25, 118, 210, 0.05) !important;
}

/* Tabs Styling */
.custom-tabs >>> .v-tabs-bar {
    background-color: transparent !important;
}

.transparent-tabs-item {
    background-color: transparent !important;
}

/* Text Utilities */
.letter-spacing-1 {
    letter-spacing: 1px;
}

/* Animations */
.animate-fade-in {
    animation: fadeIn 0.4s ease-out;
}

.shadow-soft {
    box-shadow: 0 4px 20px rgba(0,0,0,0.08) !important;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Theme Aware Dialog/Card */
.theme-aware-dialog {
    border-radius: 24px !important;
}

.theme-aware-card {
    background-color: var(--v-background-base, #ffffff) !important;
}

.theme--dark .theme-aware-card {
    background-color: var(--v-background-base, #1e1e2e) !important;
}

/* Legacy Overrides */
.cd {
  overflow: scroll;
}

.v-tabs-items {
  overflow: auto;
}

.botonSalir {
  position: fixed;
  top: 5px;
  right: 5px;
}
</style>